<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Clientes</p>
        </div>

        <div class="c2b-content">
            <div class="modal" tabindex="-1" role="dialog" id="c2b-subscriber-list-filter-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Nome</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberFilterForm.name" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>CNPJ</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberFilterForm.document" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Chave pública</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberFilterForm.publicKey" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Alias</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberFilterForm.alias" />
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Id externo</label>
                                    <input type="text" 
                                        class="form-control"
                                        v-model="subscriberFilterForm.idExternal" />
                                </div>

                                <div class="col-12 form-group">
                                    <label>Tipo de cliente</label>
                                    <multiselect
                                        v-model="subscriberFilterForm.isCustomer"
                                        :options="isCustomerOptions"
                                        :multiple="false"
                                        :show-labels="false"
                                        label="description"
                                        track-by="bool"
                                        placeholder="" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getSubscriberListWithFilter(subscriberFilterForm)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <SubscriberSpecificCmp ref="subscriberSpecific" />

            <Loading v-if="loading" />

            <div v-show="!loading">
                <div class="mb-3">
                    <button class="btn btn-primary" @click="openFilterModal()">
                        Filtro
                    </button>

                    <div class="btn-group ml-3" 
                        v-show="userAuthenticated.hasRoleAdmin() || userAuthenticated.hasRoleBiller()">
                        <div class="btn-group">
                            <button type="button" 
                                class="btn btn-outline-secondary dropdown-toggle" 
                                data-toggle="dropdown">
                                Relatórios
                            </button>
                            <div class="dropdown-menu">
                                <span class="dropdown-item"
                                    @click="gotoSubscribersNonPayingList()">
                                    Não pagantes
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <FilterInformationCmp 
                    v-if="!loading"
                    :filter-submitted="subscriberFilterSubmitted"
                    :filter-properties="subscriberFilterProperties" />

                <NothingFound v-if="nothingToShow" />

                <div class="table-responsive" v-show="!nothingToShow">
                    <table class="table table-hover table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>CNPJ</th>
                                <th>Código C2B</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(subscriber, index) of subscriberList" :key="index">
                                <td>
                                    <p class="mb-0">{{subscriber.realName}}</p>
                                    <small class="text-muted">{{subscriber.name}}</small>
                                    <br>
                                    <small class="text-muted">{{subscriber.alias}}</small>
                                </td>
                                <td>{{subscriber.document}}</td>
                                <td>{{subscriber.idExternal}}</td>
                                <td class="text-center c2b-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!subscriber.loadingListAction"/>
                                        <fa icon="sync-alt" spin v-show="subscriber.loadingListAction"/>
                                    </button>

                                    <div class="dropdown-menu">  
                                        <span class="dropdown-item" 
                                            @click="openSpecificSubscriberModel(subscriber)">Detalhes</span>

                                        <p class="dropdown-divider"></p>

                                        <a class="dropdown-item" 
                                            :href="redirectToBillingList(subscriber)"
                                            target="_blank">
                                            Ir para cobranças <fa icon="external-link-alt" class="ml-2 text-muted" />
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="subscriberList.length" />
                </div>

                <div v-if="showPaginationButton" class="text-center">
                    <button class="btn btn-outline-secondary"
                        @click="getMoreSubscribers()"
                        :disabled="loadingNextPage">
                        <span v-show="!loadingNextPage">Mais resultados</span>
                        <fa v-show="loadingNextPage" icon="sync-alt" spin/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PaginationModel } from '@/utils/models/PaginationModel'
import { SubscriberListFilterFormModel } from '../models/SubscriberListFilterFormModel'
import subscriberService from '../services/SubscriberService'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import ModalService from '@/utils/services/ModalService'
import { cloneDeep } from 'lodash'
import { SubscriberModel } from '../models/SubscriberModel'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import SubscriberSpecificCmp from '../components/SubscriberSpecificCmp'
import { mapState } from 'vuex'

const ID_SUBSCRIBER_LIST_FILTER_MODAL = '#c2b-subscriber-list-filter-modal'

export default {
    name: 'SubscriberListView',
    filters: {
        infoOrPlaceholder,
    },
    components: {
        FilterInformationCmp,
        SubscriberSpecificCmp,
    },
    data() {
        return {
            loading: true,
            loadingNextPage: false,
            loadingFilter: false,
            showPaginationButton: true,
            isCustomerOptions: SubscriberListFilterFormModel.getIsCustomerList(),
            subscriberList: [],
            subscriber: new SubscriberModel(),
            subscriberFilterForm: new SubscriberListFilterFormModel(),
            subscriberFilterSubmitted: new SubscriberListFilterFormModel(),
            pagination: new PaginationModel(),
            subscriberFilterProperties: [
                {
                    type: 'string',
                    label: 'Nome',
                    property: 'name',
                },
                {
                    type: 'string',
                    label: 'CNPJ',
                    property: 'document',
                },
                {
                    type: 'string',
                    label: 'Chave pública',
                    property: 'publicKey',
                },
                {
                    type: 'string',
                    label: 'Id externo',
                    property: 'idExternal',
                },
                {
                    type: 'string',
                    label: 'Alias',
                    property: 'alias',
                },
                {
                    type: 'booleanwrapped',
                    label: 'Tipo de cliente',
                    property: 'isCustomer',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        try {
            this.subscriberList = await subscriberService.getSubscriberList(this.pagination.actual(), this.subscriberFilterForm)
            if (!this.subscriberList.length) {
                this.showPaginationButton = false
            } else {
                this.pagination.next()
            }
        } catch (err) {
            this.showPaginationButton = false
            
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getMoreSubscribers() {
            this.loadingNextPage = true

            try {
                const subscriberList = await subscriberService.getSubscriberList(this.pagination.actual(), this.subscriberFilterForm)
                if (subscriberList.length) {
                    this.subscriberList.push(...subscriberList)
                    this.pagination.next()
                } else {
                    this.showPaginationButton = false
                }
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }            

            this.loadingNextPage = false
        },
        async getSubscriberListWithFilter(subscriberFilter) {
            this.loadingFilter = true

            this.subscriberFilterSubmitted = cloneDeep(subscriberFilter)
            
            try {
                this.pagination.reset()
                this.subscriberList = await subscriberService.getSubscriberList(this.pagination.actual(), this.subscriberFilterSubmitted)
                if (!!this.subscriberList.length) {
                    this.showPaginationButton = true
                    this.pagination.next()
                } else {
                    this.showPaginationButton = false
                }
                this.closeFilterModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilter = false
        },
        clearFilter() {
            this.subscriberFilterForm = new SubscriberListFilterFormModel()
        },
        async openFilterModal() {
            ModalService.show(ID_SUBSCRIBER_LIST_FILTER_MODAL)
        },
        closeFilterModal() {
            ModalService.hide(ID_SUBSCRIBER_LIST_FILTER_MODAL)
        },
        async openSpecificSubscriberModel(sub) {
            sub.loadingListAction = true

            await this.$refs.subscriberSpecific.openModal(sub.id)

            sub.loadingListAction = false
        },
        gotoSubscribersNonPayingList() {
            this.$router.push('/clientes/nao-pagantes')
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
        }),
        nothingToShow() {
            return !this.loading && !this.subscriberList.length
        },
        redirectToBillingList() {
            return (subscriber) => {
                return `/faturamento?idSubscriber=${subscriber.id}`
            }
        },
    },
}
</script>
